<script lang="ts">
import ClientStateFilterList from '../components/ClientStateFilterList.vue';

/** Issuers list. Client-side state filtering - see ClientStateFilterList. */
export default { name: 'ListCertManagerIssuer', extends: ClientStateFilterList };
</script>
